import React from 'react'
import { LogoIcon } from 'transfix-ui/components/LogoIcon'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { makeStyles } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'

const useNavLogoStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
}))

const NavLogo = () => {
  const { isMobile } = useBreakpointContext()
  const classes = useNavLogoStyles()
  return (
    <div className={classes.root} data-test='NavLogo'>
      {isMobile ? (
        <LogoIcon size='xsmall' color='white' />
      ) : (
        <LogoTransfix color='white' width={140} />
      )}
    </div>
  )
}

export default NavLogo
